import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';
import TagsCard from 'bundles/tags/tags_card';

export default class BulkTaggingModal extends React.Component {

  static propTypes = {
    buttonText: PropTypes.string.isRequired,
    paths: PropTypes.object.isRequired,
    selectedIds: PropTypes.array.isRequired,
    shown: PropTypes.bool.isRequired,
    tags: PropTypes.array.isRequired,
    onBulkTag: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSetBulkTags: PropTypes.func.isRequired
  };

  handleBulkTagging = () => {
    const { tags, selectedIds, onBulkTag, onCancel } = this.props;
    onBulkTag(tags, selectedIds);
    onCancel();
  }

  handleAddTag = (tag) => {
    const { tags, onSetBulkTags } = this.props;
    tags.push(tag);
    onSetBulkTags(tags);
  }

  handleRemoveTag = (tag) => {
    const { tags, onSetBulkTags } = this.props;
    const newTags = tags.filter(t => t !== tag);
    onSetBulkTags(newTags);
  }

  render() {
    const {
      buttonText,
      paths,
      shown,
      tags,
      onCancel
    } = this.props;

    return (
      <Modal show={shown} onHide={onCancel}>
        <Modal.Header closeButton>
          <Modal.Title>Bulk Tagging</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TagsCard
            active={true}
            paths={paths}
            tags={tags}
            onAdd={this.handleAddTag}
            onRemove={this.handleRemoveTag}
          />
        </Modal.Body>
        <Modal.Footer className="text-left">
          <button className='btn btn-sm btn-cancel' onClick={onCancel}>Cancel</button>
          <button
            className='btn btn-sm btn-save'
            onClick={this.handleBulkTagging}
          >
            {buttonText}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
